import { DeleteOutlined, EditOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, message, Popconfirm, Radio, Space, Spin, Switch, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import CompanyToken from "./company-token";

const CompanyTokens = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTokenId, setSelectedTokenId] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingToken, setEditingToken] = useState(null);
  const isMobile = useViewportBreakpoint() === "mobile";

  const getData = () => {
    setLoading(true);
    serverFetch("token?internalOnly=true")
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };

  useEffect(getData, []);

  const handleAdd = () => {
    setEditingToken(null);
    setEditModalVisible(true);
  };

  const handleEdit = () => {
    if (!selectedTokenId) return message.warning("Выберите токен для редактирования");
    const token = items.find(item => item.id === selectedTokenId);
    if (token) {
      setEditingToken(token);
      setEditModalVisible(true);
    }
  };

  const deleteTokenById = id => {
    setLoading(true);
    serverFetch(`token/${id}`, { method: "DELETE" })
      .then(() => {
        message.success("Токен удален");
        if (selectedTokenId === id) setSelectedTokenId(null);
        getData();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка при удалении");
      });
  };

  const handleCloseModal = refresh => {
    setEditModalVisible(false);
    setEditingToken(null);
    if (refresh) getData();
  };

  const columns = [
    {
      title: "",
      width: 50,
      render: (_, record) => (
        <Radio checked={selectedTokenId === record.id} onChange={() => setSelectedTokenId(record.id)} />
      ),
    },
    { dataIndex: "id", title: "#", width: 80 },
    { dataIndex: "code", title: "Код", width: 300 },
    { dataIndex: "active", title: "Активен", width: 100, render: value => (value ? "Да" : "Нет") },
  ];

  return (
    <>
      {isMobile ? (
        <div className="company-tokens-toolbar-mobile">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAdd}
            disabled={loading}
            aria-label="Добавить"
            className="company-tokens-toolbar-icon-btn"
          />
          <Button
            icon={<ReloadOutlined />}
            onClick={getData}
            disabled={loading}
            loading={loading}
            aria-label="Обновить"
            className="company-tokens-toolbar-icon-btn"
          />
        </div>
      ) : (
        <Space style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={handleAdd} disabled={loading}>
            Добавить
          </Button>
          <Button onClick={handleEdit} disabled={!selectedTokenId || loading}>
            Редактировать
          </Button>
          <Popconfirm
            title="Подтверждение удаления"
            description="Вы уверены, что хотите удалить этот токен?"
            onConfirm={() => deleteTokenById(selectedTokenId)}
            okText="Удалить"
            cancelText="Отмена"
            disabled={!selectedTokenId}
          >
            <Button danger disabled={!selectedTokenId || loading}>
              Удалить
            </Button>
          </Popconfirm>
          <Button onClick={getData} disabled={loading}>
            Обновить
          </Button>
        </Space>
      )}

      {isMobile ? (
        <Spin spinning={loading}>
          <div className="company-tokens-list">
            {items.map(item => (
              <div key={item.id} className="company-tokens-card">
                <div className="company-tokens-card-header">
                  <div className="company-tokens-card-row1">
                    <Switch checked={item.active} disabled size="small" aria-label="Активен" />
                    <span className="company-tokens-card-hash">#{item.id}</span>
                  </div>
                  <div className="company-tokens-card-actions">
                    <Button
                      type="default"
                      size="small"
                      icon={<EditOutlined />}
                      className="company-tokens-card-icon-btn"
                      onClick={() => {
                        setEditingToken(item);
                        setEditModalVisible(true);
                      }}
                      aria-label="Редактировать"
                    />
                    <Popconfirm
                      title="Подтверждение удаления"
                      description="Вы уверены, что хотите удалить этот токен?"
                      onConfirm={() => deleteTokenById(item.id)}
                      okText="Удалить"
                      cancelText="Отмена"
                    >
                      <Button
                        danger
                        type="default"
                        size="small"
                        icon={<DeleteOutlined />}
                        className="company-tokens-card-icon-btn"
                        disabled={loading}
                        aria-label="Удалить"
                      />
                    </Popconfirm>
                  </div>
                </div>
                <div className="company-tokens-card-code">{item.code}</div>
              </div>
            ))}
          </div>
        </Spin>
      ) : (
        <Table
          columns={columns}
          dataSource={items}
          loading={loading}
          rowKey="id"
          size="small"
          scroll={{ x: "max-content" }}
          pagination={false}
        />
      )}

      {editModalVisible && (
        <CompanyToken token={editingToken} visible={editModalVisible} onClose={handleCloseModal} />
      )}
    </>
  );
};

export default CompanyTokens;
